"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Today_1 = __importDefault(require("@material-ui/icons/Today"));
var useStatusClass_1 = __importDefault(require("./useStatusClass"));
var types_1 = require("../../types");
var useStyles = styles_1.makeStyles({
    root: {
        height: '100%',
        width: '100%',
        border: 0,
        padding: 0,
    },
    icon: {
        float: 'right',
        marginRight: 5,
    },
    readout: {
        color: 'black',
        float: 'left',
        marginLeft: 5,
    },
});
var DocumentPageTimestampInput = function (_a) {
    var onChange = _a.onChange, onFocus = _a.onFocus, input = _a.input;
    var dateFormat = input.dateFormat, id = input.id, status = input.status, value = input.value;
    var classes = useStyles();
    var statusClass = useStatusClass_1.default(status);
    return (react_1.default.createElement("button", { className: statusClass + " " + classes.root, "data-tid": "DocumentPageTimestampInput-button-" + id, disabled: status === types_1.PageInputStatus.Disabled, onClick: function () { return onChange(new Date()); }, onFocus: function () { return onFocus(); } },
        react_1.default.createElement("span", { className: classes.readout }, value
            ? date_fns_1.format(value, dateFormat || 'P') // P means localized short date
            : '- click to set -'),
        react_1.default.createElement(Today_1.default, { className: classes.icon })));
};
exports.default = DocumentPageTimestampInput;
//# sourceMappingURL=DocumentPageTimestampInput.js.map